import React from 'react';
import TopicPage from '../../../components/TopicPageNew';
import bg from '../../../assets/history2/History_of_Sci_&_Tech_-_Medical_Breakthroughs_e.g._Vaccines_DNA.png';

function HistoryPageMedicalBreakthroughs() {
  return (
    <TopicPage
      topicKey="Medical Breakthroughs (e.g., Vaccines, DNA)"
      title="History: Medical Breakthroughs"
      backgroundImage={bg}
      startRoute="/History-Medical-Breakthroughs-Go"
      scrollLabels={[
        "Vaccines and Immunization",
        "DNA and Genetic Discoveries",
        "Global Health Improvements",
      ]}
      backRoute="/history-host"
      backLabel="← Return to topics"
      backButtonClassName="journey-button special"
      backButtonStyle={{ fontSize: '1.1rem', backgroundColor: '#553c0d' }}
    />
  );
}

export default HistoryPageMedicalBreakthroughs;
